import {  useRef} from 'react';

const Homepagesection = () => {
   const sliderRef = useRef(null);

  const handleNext = () => {
    const slider = sliderRef.current;
    if (slider) {
      const slideWidth = slider.clientWidth;
      slider.scrollBy({ left: slideWidth, behavior: 'smooth' });
    }
  };

  const handlePrev = () => {
    const slider = sliderRef.current;
    if (slider) {
      const slideWidth = slider.clientWidth;
      slider.scrollBy({ left: -slideWidth, behavior: 'smooth' });
    }
  };


  return (
    <div className="slider-container" id="slider">

      {/* Main Content Section */}
      <section className="intro">
        <h2>Introduction</h2>
        <p>
          Construction Estimation helps professionals in the construction industry get accurate estimations for their building projects. Please ensure you enter values in <b>meters</b>, not millimeters.
        </p>
      </section>
<div className='educative-wrapper'>
   {/* Arrows (mobile only) */}
        <button className="arrow-btn left" onClick={handlePrev}>&#8592;</button>
      {/* Educative Section */}
      <section className="educative" ref={sliderRef}>

 
  <div className="slide">
  <h2>Did You Know?</h2>
  <ul>
    <li>The Burj Khalifa used over 22 million man-hours and advanced concrete to reach record height.</li>
    <li>The Great Wall of China stretches over 13,000 miles and took centuries to complete.</li>
    <li>Modern skyscrapers rely on concrete that handles massive pressure without cracking or deforming.</li>
    <li>Ancient Roman builders used volcanic ash to create concrete that still stands today.</li>
    <li>New bridges use self-healing concrete that seals cracks automatically over time.</li>
  </ul>
</div>



      <div className="slide">
  <h2>Some Tips for Your Construction Projects</h2>
  <ul>
    <li><b>Double-check measurements</b> before cutting to avoid mistakes and material waste.</li>
    <li><b>Allow concrete enough time to cure </b> before applying any load or finishing work.</li>
    <li><b>Use local and eco-friendly materials</b> to reduce environmental impact and cost.</li>
    <li><b>Keep records of labor, materials, and spending</b> to track your project budget.</li>
    <li><b>Communicate clearly </b> with workers and supervisors to prevent delays or rework.</li>
  </ul>
</div>



      <div className="slide">
  <h2>Top 5 Construction Tips</h2>
  <ul>
    <li><b>Plan First</b>: Use proper blueprints and measurements before starting any work.</li>
    <li><b>Buy Quality</b>: Cheap materials can fail quickly and cost more long term.</li>
    <li><b>Stay Safe</b>: Always wear protective gear and follow safety procedures.</li>
    <li><b>Check Drainage</b>: Poor drainage weakens structures and foundations.</li>
    <li><b>Inspect Often</b>: Regular checks help fix problems early and ensure standards.</li>
  </ul>
</div>



<div className="slide">
  <h2>Sustainable Building Practices</h2>
  <ul>
    <li> <b> Use reclaimed materials </b> like steel, wood, or plastic to cut cost and waste.</li>
    <li><b>Add insulation and LED lighting</b> to reduce energy use in buildings.</li>
    <li><b>Install solar panels or wind turbines </b> for cleaner, renewable energy.</li>
    <li><b>Use low-flow taps and rainwater systems </b> to save water on site.</li>
    <li><b>Grow rooftop plants</b> to improve insulation and lower urban heat levels.</li>
  </ul>
</div>



 <div className="slide">
  <h2>Construction Innovations</h2>
  <b>Modern technology is reshaping construction with faster, safer, and smarter methods.</b>
  <ul>
    <li><b>3D Printing</b>: Builds structures faster with less labor and material waste.</li>
    <li><b>Drones</b>: Help with aerial views, progress tracking, and inspections.</li>
    <li><b>Smart Materials</b>: Use self-healing concrete and temperature-sensitive insulation.</li>
    <li><b>AI & Robotics</b>: Handle repetitive tasks like digging or bricklaying efficiently.</li>
    <li><b>Digital Twins</b>: Create virtual sites for better planning and risk reduction.</li>
  </ul>
</div>


       <div className="slide">
  <h2>Essential Construction Safety Training Topics</h2>
  <b>Comprehensive safety training is vital for protecting workers on construction sites. Key topics include:</b>
  <ul>
    <li><b>Fall Protection</b>: Use of harnesses, guardrails, and proper ladder safety.</li>
    <li><b>Electrical Safety</b>: Safe handling of wires, panels, and live equipment.</li>
    <li><b>Material Handling</b>: Correct lifting, storage, and use of protective gear.</li>
    <li><b>Cranes & Rigging</b>: Load safety and clear signals for lifting operations.</li>
    <li><b>Fire Safety</b>: Training on extinguishers, exits, and evacuation plans.</li>
  </ul>
</div>

       
      </section>
      <button className="arrow-btn right" onClick={handleNext}>&#8594;</button>
      </div>
           
</div>  
  );
};

export default Homepagesection;
